<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 18:24:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-07 11:48:54
 * @name: 步骤进度
 * @Description: 步骤进度
 * @FilePath: \backstage\src\components\register\step.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
    <div class="step">
        <div class="item" v-for="(item, index) of list" :key="index" :class="{active: step === index + 1}">
            <div>{{ index + 1 }}</div>
            <font>{{ item }}</font>
        </div>
    </div>
</template>
<script>
export default {
    name: 'registerStep',
    props: {
        step: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            list: ['填写手机号','完善信息','注册成功'],
        }
    },
}
</script>
<style lang="scss" scoped>
    .step{
        width: 100%;
        height: 120px;
        flex-shrink: 0;
        background: $Vars-background-light-gray;
        box-sizing: border-box;
        padding: 0 120px;
        @extend .extend-flex-spacebetween;
        .item{
            @extend .extend-flex-start;
            div{
                width: 40px;
                height: 40px;
                border-radius: 40px;
                @extend .extend-flex-center;
                box-sizing: border-box;
                border: 2px solid $Vars-normal-color;
                color: $Vars-normal-color;
                background: $Vars-base-color-white;
                margin-right: 18px;
                font-size: $Vars-font-mainTitle-size;
            }
            font{
                font-size: $Vars-font-mainTitle-size;
                color: $Vars-font-important-color;
            }
            &.active{
                div{
                    background: $Vars-normal-color;
                    color: $Vars-base-color-white;
                }
                font{
                    color: $Vars-normal-color;
                }
            }
        }
    }
</style>